import LocalizedStrings from 'react-localization'

export const strings = new LocalizedStrings({
  en: {
    createdAtColumn: 'Created At',
    emailColumn: 'Email',
    updatedAtColumn: 'Updated At',
  },
})
